import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

const DURATION = 2 // segundos
const LOOPS = 0.9 // voltas na borda antes de assentar
const SEGMENT_FRACTION = 0.1 // comprimento do "cometa" como fração do perímetro

const Banner = ({ message, action, icon, children, animated }) => {
  const classes = useStyles()
  const comet1Ref = useRef(null)
  const comet2Ref = useRef(null)
  const [finished, setFinished] = useState(false)

  useEffect(() => {
    const comet1 = comet1Ref.current
    const comet2 = comet2Ref.current
    if (!animated || !comet1 || !comet2) return

    const perimeter = comet1.getTotalLength()
    const segment = perimeter * SEGMENT_FRACTION
    const dashArray = `${segment} ${perimeter - segment}`
    comet1.style.strokeDasharray = dashArray
    comet2.style.strokeDasharray = dashArray

    let startTime = null
    let rafId = null

    function tick(timestamp) {
      if (!startTime) startTime = timestamp
      const elapsed = (timestamp - startTime) / 1000

      if (elapsed >= DURATION) {
        setFinished(true)
        return
      }

      const travel = (elapsed / DURATION) * perimeter * LOOPS
      // Dois cometas no mesmo sentido, sempre defasados em meio perímetro,
      // para nunca se cruzarem.
      comet1.style.strokeDashoffset = String(-travel)
      comet2.style.strokeDashoffset = String(-travel + perimeter / 2)
      rafId = requestAnimationFrame(tick)
    }

    rafId = requestAnimationFrame(tick)
    return () => {
      if (rafId) cancelAnimationFrame(rafId)
    }
  }, [animated])

  return (
    <Box className={classes.root}>
      {animated && (
        <svg className={classes.svg}>
          <rect
            ref={comet1Ref}
            className={clsx(classes.comet, { [classes.hidden]: finished })}
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
          <rect
            ref={comet2Ref}
            className={clsx(classes.comet, { [classes.hidden]: finished })}
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
          <rect
            className={clsx(classes.border, { [classes.shown]: finished })}
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
        </svg>
      )}
      <Box className={classes.content}>
        {icon}
        {message && (
          <Typography className={classes.message} variant="subtitle1">
            {message}
          </Typography>
        )}
        {children}
      </Box>
      {action && <Box className={classes.action}>{action}</Box>}
    </Box>
  )
}

Banner.propTypes = {
  message: PropTypes.node,
  action: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
  animated: PropTypes.bool,
}

export default Banner
